import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState } from 'react';
import { styled } from '@linaria/react';
import cls from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

const NOOP = () => null;

export const StyledHamburger = /*#__PURE__*/styled("button")({
  name: "StyledHamburger",
  class: "snlgog7",
  vars: {
    "snlgog7-0": [props => props.scale ? "scale(".concat(props.scale, ")") : 'none']
  }
});
export const StyledHamburgerIcon = /*#__PURE__*/styled("div")({
  name: "StyledHamburgerIcon",
  class: "shsqkjt",
  vars: {
    "shsqkjt-0": [() => "url('/api/noise.svg?opacity=.4'), var(--clr-primary)"]
  }
});
export const HamburgerIcon = props => {
  return /*#__PURE__*/_jsx(StyledHamburgerIcon, {
    className: cls('hamburger-icon', {
      active: props.open === true
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: "hamburger-inner"
    })
  });
};
export const HamburgerButton = props => {
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  return /*#__PURE__*/_jsx(StyledHamburger, _objectSpread(_objectSpread({}, props), {}, {
    "aria-label": "hamburger menu",
    onClick: event => {
      setIsOpen(!isOpen);
      return (props.onClick || NOOP)(event);
    },
    children: /*#__PURE__*/_jsx("div", {
      className: cls('hamburger-icon', {
        active: isOpen == true
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: "hamburger-inner"
      })
    })
  }));
};

require("./HamburgerButton.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./HamburgerButton.tsx");